var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "a",
    {
      staticClass: "search-preview",
      attrs: { href: _vm.props.item.url + "#stage" + _vm.props.item.id }
    },
    [
      _c("span", { staticClass: "search-preview__img-wrap" }, [
        _c("img", {
          staticClass: "search-preview__img",
          attrs: { src: _vm.props.item.image }
        })
      ]),
      _c("span", { staticClass: "search-preview__info" }, [
        _c("span", {
          staticClass: "search-preview__title",
          domProps: {
            innerHTML: _vm._s(
              _vm.props.fn(
                _vm.props.item.title,
                _vm.props.item.title,
                _vm.props.localsearch
              )
            )
          }
        }),
        _c("span", {
          staticClass: "search-preview__text",
          domProps: {
            innerHTML: _vm._s(
              _vm.props.fn_html(
                _vm.props.item.description,
                _vm.props.localsearch
              )
            )
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38a67f62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a67f62","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/search/parts/stages.vue
// module id = 226
// module chunks = 4